import { render, staticRenderFns } from "./OfferCreate.vue?vue&type=template&id=0f8f2d3e&scoped=true&"
import script from "./OfferCreate.vue?vue&type=script&lang=js&"
export * from "./OfferCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfferCreate.vue?vue&type=style&index=0&id=0f8f2d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f2d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8f2d3e')) {
      api.createRecord('0f8f2d3e', component.options)
    } else {
      api.reload('0f8f2d3e', component.options)
    }
    module.hot.accept("./OfferCreate.vue?vue&type=template&id=0f8f2d3e&scoped=true&", function () {
      api.rerender('0f8f2d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/OfferCreate.vue"
export default component.exports